import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteReportById } from '@services/api/reportAPI'

const useDeleteReport = () => {
  const queryClient = useQueryClient()
  const deleteReport = useMutation({
    mutationFn: reportId => deleteReportById(reportId),
    onSettled: async () => {
      await queryClient.invalidateQueries(['products'])
    },
  })

  return { deleteReport }
}

export { useDeleteReport }
